import { lazy } from "@bridgesplit/ui";

const ManagerOverview = lazy(() => import("./ManagerOverview"));

export { ManagerOverview };

export * from "./type";
export * from "./dialogs";
